export enum EditOnlineSideNavAction {
  inviteesRegistrations = 'inviteesRegistrations',
}
